import React, { useState, useEffect } from "react";

import { Row, Col, Button } from "react-bootstrap";
import "./SessionMain.css";
import BootstrapTable from "react-bootstrap-table-next";




  export default function SessionMain2OutputTable(props) {

   // const [FarmList, setFarmList] = useState([]);


  const [tableData, setTableData] = useState([])

    

  useEffect(() => {
  
   
    let map = props.CountersMap;

    let oo = [];
    let numOuts = props.Data.length;
    for (let i=0; i<numOuts; i++){
       let o = props.Data[i];
       let strOrigin = "";
       let numCounters = parseInt(o.FromChannelCount );
       for (let j=0; j<numCounters; j++){
        let gtIdx = parseInt (o["FromCounter"+j])
        let ch =  parseInt (o["FromChannel"+j]) + 1;
        if (strOrigin != ""){
          strOrigin += " ";
        }
        
        strOrigin += "Cntr"+map[gtIdx]+"/Ch"+ch;

       } 
       o["Source"] = strOrigin ;
       oo.push(o);
    }
    setTableData (oo);




  }, [props]);



  let columns = [
    {
    dataField: 'Name',
    text: 'Output'

  },
  {
    dataField: 'Origin',
    text: 'Origin'

  }, 
  {
    dataField: 'Destination',
    text: 'Destination'

  }, 
  {
    dataField: 'FishCount',
    text: 'Count',
    formatter: (v)=>{  return parseInt(v, 10).toLocaleString()} 

  },
  /* 
  {
    dataField: 'Percent_Count',
    text: '% Count', 
    formatter: (v) => {return v+"%"}
  },
  */ 
  {
    dataField: 'TotalBiomass',
    text: 'Biomass',
    formatter: (v)=> {return biomassFormatter(v);}
  }, 
  /*
  {
    dataField: 'Percent_Biomass',
    text: '% Biomass',
    formatter: (v) => {return v+"%"}
  },
  */ 
  {
    dataField: 'AverageWeight',
    text: 'Avg. weight (g)',
    formatter: (v)=>{return Math.round (parseFloat(v))} 
  },
  {
    dataField: "Source",
    text: "Counters"
  }
  



];
  


const biomassFormatter = (cell) => {

 

    let n = parseFloat (cell);

 
    if (isNaN(n))
        return "---";
    let str = "";
      
    if (n<1000){
        str = n+"g";
    } else if (n<10000){
        str= (n/1000).toFixed(2)+"kg";
     }
    else if (n<100000){
        str= (n/1000).toFixed(1)+"kg";
     }
    else if (n<1000000){
        str = (n/1000).toFixed(0)+"kg";
    }
    else if (n<10000000){
        str = (n/1000000).toFixed(2)+"t";
    }
     else if (n<100000000){
        str = (n/1000000).toFixed(1)+"t";
    }
    else if (n<1000000000){
        str = (n/1000000).toFixed(0)+"t";
    }
    else if (n<10000000000){
        str = (n/1000000000).toFixed(2)+"kt";
    }
    else if (n<100000000000){
        str = (n/1000000000).toFixed(1)+"kt";
    } else {
        str = (n/1000000000).toFixed(0)+"kt";
    } 

return str;

} 









//const SessionMain = props => (



  

    return(
  <div>
 
 <div className = "table-wrap"> 
     <BootstrapTable
              keyField='Name'
              data={tableData}
              columns={columns}
          
            />
    
     </div>
  
  </div>
);
};

